import type { Suggestion } from '../../../shared/types';
import { getLead } from '../data/store';
import { btn, linkBtn } from '../ui/components';
import { h } from '../ui/dom';
import { locationRepair } from './lead/locationRepair';

export const dueRow = (due: Suggestion['also_due'][number], actions: {
  include: (id: string) => void; clear: (ids: string[]) => void;
}) => {
  const el = h('div', {class:'plan__dueitem'}, `${due.name} — ${due.why}`);
  if (due.reason === 'location' || due.location_status) {
    el.append(h('a', {href:`#/leads/${encodeURIComponent(due.lead_id)}`}, ' Repair location'));
    void getLead(due.lead_id).then(lead => {if (lead) el.append(locationRepair(lead));}).catch(() => undefined);
  } else if (due.reason === 'outside_area') {
    el.append(btn('Include in this day', {variant:'ghost', onClick:() => actions.include(due.lead_id)}));
  } else if (due.reason === 'exclusion') {
    el.append(btn('Clear exclusion', {variant:'ghost', onClick:() => actions.clear(due.exclusion_ids ?? [`lead:${due.lead_id}`])}));
  } else if (due.reason) {
    const label = due.reason === 'target' ? 'Raise stop target' :
      due.reason === 'day' || due.reason === 'meeting_conflict' ? 'Extend day' : 'Adjust hours settings';
    el.append(linkBtn(label, '#/route/settings', {variant:'ghost'}));
    el.append(linkBtn('Reschedule follow-up', `#/leads/${encodeURIComponent(due.lead_id)}`, {variant:'ghost'}));
  }
  return el;
};
